import {Component} from '@angular/core';
import {AppMainComponent} from '../../app.main.component';
import { NgClass } from '@angular/common';
// import { MainStateService } from '../mainstate.service';

@Component({
    standalone: true,
    selector: 'app-rightmenu',
    templateUrl: './app.rightmenu.component.html',
    imports:[
        NgClass
    ]
})
export class AppRightMenuComponent {
    date: Date;

    constructor(public appMain: AppMainComponent) {}
}
